import React, {createRef, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
// import { httpPaginationPost } from "../../../util/Rest";
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import AddIcon from '@material-ui/icons/Add';

// import GetAppIcon from "@material-ui/icons/GetApp";  may require
import {ThemeContext} from '../../../../themes/ThemeProvider';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';

export default function EventClientSearchTable({
  setValue,
  searchData,
  setEventTacticCode,
  // setSelectedRows,
  // selectedRows,
  // setBreCode,
  // viewRuleGroupData,
  // setViewRuleGroupData,
}) {
  const columns = [
    {
      title: 'Client Id',
      field: 'clientId',
    },
    {
      title: 'Event Tactic',
      field: 'eventTactic',
    },
    {
      title: 'Agency',
      field: 'agency',
    },
    {
      title: 'Event Type',
      field: 'eventType',
    },
  ];
  // const [countTotal, setCountTotal] = useState('');
  const countTotal = '';
  // const classes = useStyles();
  const tableRef = createRef();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [rows, setRows] = useState(defaultRows);
  //   useEffect(() => {
  //     if (tableRef?.current) {
  //       Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : "";
  //     }
  //   }, [searchData]);

  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons">
          <GuiTable
            title={
              <div>
                {countTotal && (
                  <p className={classes.searchText}>
                    We found {`"${countTotal}"`} {countTotal === 1 ? 'result' : 'results'}
                  </p>
                )}
              </div>
            }
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={[]}
            // data={(query) => **Code may require
            //   new Promise((resolve) => {
            //     const url = `event/search/all`;
            //     const bodyObj = {
            //       code: searchData?.code ? searchData.code : "",
            //       description: searchData?.description ? searchData?.description : "",
            //       limit: query.pageSize ? query.pageSize : null,
            //       page:
            //         arrayLast && query?.page >= 1
            //           ? query.page
            //           : arrayLast
            //           ? (query.page <= 1 && query.page + 1) || query.page - 1
            //           : query.page + 1,
            //     };
            //     if (!searchData) {
            //       resolve({
            //         data: [],
            //         page: 0,
            //         totalCount: 0,
            //       });
            //     } else {
            //       httpPaginationPost(url, bodyObj)
            //         .then((response) => {
            //           if (response?.status === 200) {
            //             const data = response.data.response.resultObject;

            //             resolve({
            //               data: data.length > 0 ? data : [],
            //               page: response.data.response.page - 1,
            //               totalCount: response.data.response.count,
            //             });
            //             setCountTotal(response.data.response.count);
            //             setArrayLast(data.length === 1);
            //           } else {
            //             resolve({
            //               data: [],
            //               page: 0,
            //               totalCount: 5,
            //             });
            //             dispatch({
            //               type: "FETCH_ERROR",
            //               payload: response && response.message ? response.message : null,
            //             });
            //           }
            //         })
            //         .catch((response) => {
            //           resolve({
            //             data: [],
            //             page: 0,
            //             totalCount: 5,
            //           });
            //           dispatch({
            //             type: "FETCH_ERROR",
            //             payload: response && response.message ? response.message : null,
            //           });
            //         });
            //     }
            //   })
            // }
            options={{
              search: false,
              // selection: true,
              pageSize: rows,
              toolbar: true,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button
                      variant="contained"
                      className={`themeing-buttons ${classes.buttonRoot}`}
                    >
                      <AddIcon /> Attach Client Event Tactics
                    </Button>
                  </div>
                ),
                isFreeAction: true,
                onClick: () => {
                  setValue(1);
                },
              },
            ]}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onRowClick={(event, rowData) => {
              setValue(1);
              setEventTacticCode(rowData.code);
              // setBreCode(rowData.code);
            }}
          />
        </div>
      </Grid>
    </>
  );
}
